import * as React from 'react';

class Faq extends React.Component {

    public render() {
        return (
            <div>
                FAQ
            </div>
        );
    }
}

export default Faq;



// WEBPACK FOOTER //
// ./src/Faq/Faq.tsx